import { Injectable, Inject, OnDestroy, DOCUMENT } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { UserService } from '@app/common/security/user.service';
import { Subscription } from 'rxjs';
import { OnlineStatusService } from '../online-status/online-status.service';
import { OnlineStatusType } from '../online-status/online-status-type.enum';
import { ConfigurationHelperService } from '@app/common/app-configuration/configuration-helper.service';

@Injectable()
export class AuthGuard  implements OnDestroy {

    theSubscription: Subscription;
    isOffline: boolean;

    constructor(
        private router: Router,
        private configurationHelperService: ConfigurationHelperService,
        @Inject(UserService) private userService: UserService,
        @Inject(DOCUMENT) private document: Document,
        private onlineStatusService: OnlineStatusService,
    ) {
        this.onlineStatusService.getCurrentStatus().subscribe(x => {
            this.isOffline = (x === OnlineStatusType.OFFLINE);
        }, error => {
            this.isOffline = false;
        });

        this.theSubscription = this.onlineStatusService.status.subscribe(
            event => {
                this.isOffline = (event === OnlineStatusType.OFFLINE) ? true : false;
            }
        );
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        this.isOffline = await this.onlineStatusService.isOffline().toPromise();
        await this.userService.getCurrentUserAwaitable(this.isOffline);

        if (this.userService.currentUser  && (this.isOffline ||
            (this.userService.currentUser.authenticationDetails
            && this.userService.currentUser.authenticationDetails.isLoggedOut === false))) {
                if (this.userService.currentUser.userAccount.shouldResetPassword) {
                    this.document.location.href = this.configurationHelperService.getPasswordResetUri();
                }
                if (this.userService.currentUser.userAccount.shouldAgreeToTermsAndConditions) {
                    this.document.location.href = this.configurationHelperService.getTermsAndConditionsAgreementUri();
                }
                return true;

        }

        this.router.navigate(['/authentication'], { queryParams: { ReturnUrl: state.url } });
        return false;
    }

    ngOnDestroy(): void {
        this.theSubscription.unsubscribe();
    }
}
